import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { PureAbility } from '@casl/ability';
import { CustomRouteData } from './custom-route.interface';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard {
  private router = inject(Router);
  private ability = inject(PureAbility);

  canActivateChild(childRoute: ActivatedRouteSnapshot): boolean | UrlTree {
    const permission = (childRoute.data as CustomRouteData)?.permission;

    if (permission) {
      const hasAccess = permission.some((p) =>
        this.ability.can(p.action, p.subject)
      );

      if (!hasAccess) {
        console.error(
          `PermissionGuard: None of the permissions found: ${permission.map((p) => p.action + ' ' + p.subject).join(', ')}`
        );
        return this.router.parseUrl('/forbidden');
      }

      return hasAccess;
    } else {
      return true;
    }
  }
}
